import { titleize } from '@ltvco/refresh-lib/utils';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import {
  CardContainer,
  CardHeaderRow,
  FieldList,
  ReportFieldRow,
  ReportTitle,
  SectionDivider,
  SeeFullReportCTA,
  ViewReportButton,
} from '../../components';
import { formatAliases } from '../utils';

import { AncestryRelativesSection, LifeEventsSection } from './sections';

import type {
  AncestryReportData,
  AncestryReportLifeEvent,
} from 'components/DeepSearch/types';

function getEventDate(event: AncestryReportLifeEvent): string {
  return event.date || event.year || '';
}

function getEventLocation(event: AncestryReportLifeEvent): string {
  return event.place || '';
}

interface AncestryReportPreviewCardProps {
  data: AncestryReportData;
  onViewReport?: () => void;
}

export const AncestryReportPreviewCard = ({
  data,
  onViewReport,
}: AncestryReportPreviewCardProps) => {
  const birthDate = getEventDate(data.birth);
  const birthLocation = getEventLocation(data.birth);
  const deathDate = getEventDate(data.death);
  const deathLocation = getEventLocation(data.death);
  const burialDate = getEventDate(data.burial);
  const burialLocation = getEventLocation(data.burial);

  return (
    <CardContainer>
      <CardHeaderRow sx={{ mb: 1 }}>
        <GroupsOutlinedIcon sx={{ fontSize: 24 }} />
        <ReportTitle m={0}>
          {(data.name && titleize(data.name.toLowerCase())) ||
            'Ancestry Report'}
        </ReportTitle>
        {onViewReport && <ViewReportButton onClick={onViewReport} />}
      </CardHeaderRow>

      <SectionDivider />

      <FieldList>
        <ReportFieldRow
          label="Aliases"
          value={
            data.aliases.length
              ? formatAliases(data.aliases)
              : 'No aliases found'
          }
        />
        <ReportFieldRow
          label="Birth Date"
          value={birthDate || 'Not available'}
        />
        <ReportFieldRow
          label="Birth Location"
          value={birthLocation || 'Not available'}
        />
        <ReportFieldRow
          label="Death Date"
          value={deathDate || 'Not available'}
        />
        <ReportFieldRow
          label="Death Location"
          value={deathLocation || 'Not available'}
        />
        <ReportFieldRow
          label="Burial Date"
          value={burialDate || 'Not available'}
        />
        <ReportFieldRow
          label="Burial Location"
          value={burialLocation || 'Not available'}
        />
      </FieldList>

      <LifeEventsSection data={data} />
      <AncestryRelativesSection data={data} />

      {onViewReport && <SeeFullReportCTA onClick={onViewReport} />}
    </CardContainer>
  );
};
